import { EventsByMonth } from "./events-by-month";


export class LengthRange {
  constructor(public id: number, public from: number | undefined, public to: number | undefined) {
  }

  public static isLengthInRange(length: number | null | undefined, range: LengthRange
  ): boolean {
    if (length == null) return false;

    if (range.from != null && length < range.from) return false;
    if (range.to != null && length >= range.to) return false;

    return true;
  }
}

export class EventFilter {

  public static readonly LENGTH_RANGES: LengthRange[] = [
    new LengthRange(1, undefined, 5),
    new LengthRange(2, 5, 10),
    new LengthRange(3, 10, 21),
    new LengthRange(4, 21, 42),
    new LengthRange(5, 42, undefined),
  ];
  name?: string;
  dateFrom?: Date;
  dateTo?: Date;
  status?: number;
  lengthFrom?: number;
  lengthTo?: number;
  sport?: number;
  sports?: number[];
  country?: number;
  countries?: number[];
  selectedMonth?: EventsByMonth;
  organiserId?: number;

  constructor(
  ) {
  }
}

export class EventFilterParams {
  name?: string;
  dateFrom?: Date;
  dateTo?: Date;
  status?: number;
  lengthFrom?: number;
  lengthTo?: number;
  sport?: number;
  sports?: number[];
  selectedMonth?: EventsByMonth;
  organiserId?: number;
  country?: number;
  countries?: number[];


  constructor(name?: string, dateFrom?: Date, dateTo?: Date,
              status?: number, lengthFrom?: number, lengthTo?: number,
              sport?: number, sports?: number[], selectedMonth?: EventsByMonth,
              organiserId?: number, country?: number, countries?: number[]) {
    this.name = name;
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
    this.status = status;
    this.lengthFrom = lengthFrom;
    this.lengthTo = lengthTo;
    this.sport = sport;
    this.selectedMonth = selectedMonth;
    this.organiserId = organiserId;
    this.country = country;
    this.countries = countries;
    this.sports = sports;
  }

  public static finishedEventsParams(): EventFilterParams {
    const date = new Date();
    date.setHours(0,0,0,0,)
    return new EventFilterParams(undefined, undefined, date, undefined, undefined, undefined, undefined)
  }

  public static eventCalendarParams(): EventFilterParams {
    const date = new Date();
    date.setHours(0,0,0,0,)
    return new EventFilterParams(undefined, date, undefined, undefined, undefined, undefined, undefined)
  }

}


